import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { IoSettings, IoSettingsOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { StyledIconButton } from "../../buttons/StyledIconButton";

interface MenuTitleProps {
  title: string | ReactElement;
  icon?: ReactElement;
  orgId?: string;
  hideSettings?: boolean;
}

export const MenuTitle = ({
  title,
  orgId,
  hideSettings = false,
}: MenuTitleProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 0px 0px 0px",
          width: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.grey[700],
            fontWeight: 700,
            textTransform: "uppercase",
            lineHeight: "20px",
            padding: "8px 0px",
            maxWidth: 180,
          })}
        >
          {title}
        </Typography>
        {hideSettings ? null : (
          <StyledIconButton
            sx={() => ({
              minWidth: 45,
              minHeight: 45,
            })}
            onClick={() => navigate(`fm/${orgId}/settings`)}
          >
            <IoSettingsOutline size={20} className="outline-icon" />
            <IoSettings size={20} className="filled-icon" />
          </StyledIconButton>
        )}
      </Box>
    </Box>
  );
};
